import { mapCollection } from '../../utils/collection.utils';
import { parseNumber } from '../../utils/number.utils';
import { Incidence } from '../incidence';

export class IncidenceBuilder {
  static fromJson(json) {
    return (json)
      ? new Incidence(
        json.hash,
        json.schedulerTaskHash,
        parseNumber(json.scrapped),
        parseNumber(json.recoverable),
        parseNumber(json.finished),
        json.cause,
        json.causeDescription,
        json.userErpCode,
        json.observation,
        json.type,
        null,
        json.userHash,
        parseNumber(json.date),
        json.modelTimeLine,
        json.sentToErp,
        json.isFinished,
        json.isRecoverable,
        json.isScrapped,
        json.isPaused,
        json.manufacturingOrder
      )
      : null;
  }

  static fromList(list) {
    return mapCollection(IncidenceBuilder.fromJson, list);
  }
}



// WEBPACK FOOTER //
// /var/www/borneo/prod/borneo_app/src/app/core/models/builders/incidence.builder.ts